import {
    SendingDomainMethod,
    SendingDomainStatus,
} from "@common/types/domains/emailSending";
import type { StatusIndicatorVariant } from "@design-system/StatusIndicator/StatusIndicator";

export function sendingDomainMethodLabel(method: SendingDomainMethod): string {
    switch (method) {
        case SendingDomainMethod.dns:
            return "DNS";
        case SendingDomainMethod.smtp:
            return "SMTP";
        case SendingDomainMethod.gmail:
            return "Gmail";
    }
}

export function sendingDomainStatusLabel(status: SendingDomainStatus): string {
    switch (status) {
        case SendingDomainStatus.pending:
            return "Pending";
        case SendingDomainStatus.verified:
            return "Verified";
        case SendingDomainStatus.failed:
            return "Failed";
    }
}

export function sendingDomainStatusVariant(
    status: SendingDomainStatus,
): StatusIndicatorVariant {
    switch (status) {
        case SendingDomainStatus.pending:
            return "yellow";
        case SendingDomainStatus.verified:
            return "blue";
        case SendingDomainStatus.failed:
            return "red";
    }
}

export function smtpSecureForWellKnownPort(port: number): boolean | undefined {
    if (port === 465) {
        return true;
    }
    if (port === 587) {
        return false;
    }
    return undefined;
}
